import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartWidgetPreviewComponent } from './cart-widget-preview.component';
import { LoaderModule } from '../../app-shared/components/loader/loader.module';
import { TranslateModule } from '@ngx-translate/core';
import { RoundPipeModule } from '../../app-shared/pipes/round-pipe/round.pipe.module';
import { OrderService } from 'src/app/app-shared/services/order.service';
import { RouterModule } from '@angular/router';
import { OutsideClickModule } from '../../app-shared/directives/outside-click.module';
import {FieldSelectInputModule} from "../../app-shared";
import {ReactiveFormsModule} from "@angular/forms";
import {CartWidgetFooterModule} from "../../cart/cart-widget-footer/cart-widget-footer.module";
import {CartDetailModule} from "../../cart/cart-detail/cart-detail.module";
import {AltUnitQuantModule} from "../../app-shared/components/alt-unit-quant/alt-unit-quant.module";
import {LazyLoadingModulesModule} from "../../app-shared/directives/lazy-loading-modules.module";
import {DefaultImageModule} from "../../app-shared/directives/default-image.module";
import {SortByBooleanPipeModule} from "../../app-shared/pipes/sort-by-boolean/sort-by-boolean.pipe.module";
import {SortPipeModule} from "../../app-shared/pipes/sort-pipe/sort.pipe.module";

@NgModule({
  declarations: [CartWidgetPreviewComponent],
    imports: [
        CommonModule,
        LoaderModule,
        TranslateModule,
        RoundPipeModule,
        RouterModule,
        OutsideClickModule,
        FieldSelectInputModule,
        ReactiveFormsModule,
        CartWidgetFooterModule,
        CartDetailModule,
        AltUnitQuantModule,
        LazyLoadingModulesModule,
        DefaultImageModule,
        SortByBooleanPipeModule,
        SortPipeModule,
    ],
  exports: [CartWidgetPreviewComponent],
  providers: [OrderService],
})
export class CartWidgetPreviewModule {}
